/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable max-lines */
import type { CartItem } from '@/types';
import type MockAdapter from 'axios-mock-adapter/types';
import { paymentOptionsMock } from '@/services/mocks/payment-options.mock';
import { domainItemsMock } from '@/services/mocks/domains.mock';

export const cartMockData = getMockData();


//<------------------ITEM MOCKS IN CART------------------>
// Domain = cartMockData.items[0]
// Business Mail = cartMockData.items[1]
// VDC = cartMockData.items[2]
// Website Builder = cartMockData.items[3]
// Linux VPS = cartMockData.items[4]
// Hosting = cartMockData.items[5]

// eslint-disable-next-line max-lines-per-function
function getMockData() {
  return {
    billingProfile: {
      type: 'company',
      firstName: 'Jozef',
      lastName: 'Mak',
      organisation: 'FinancnaSpravaNasNikdyNenajde a.s.',
      street: 'Sobrance 1',
      city: 'Sobrance',
      postalCode: '073 01',
      countryCode: 'SK',
      companyId: '36421928',
      vatId: 'SK2021869234',
      emails: ['JFK@example.com', 'JFK2@example.com'],
      email: 'JFK@example.com',
      phone: '+421903111111',
    },
    domainProfileRequired: true,
    consent: {
      withdrawalConsentRequired: true,
    },
    consent3rdBilling: false,
    consent3rdDomain: true,
    domainProfile: {
      type: 'personal',
      firstName: 'Jozef',
      lastName: 'Mak',
      street: 'Sobrance 1',
      city: 'Sobrance',
      postalCode: '073 01',
      countryCode: 'SK',
      emails: ['JFK@example.com', 'JFK2@example.com'],
      email: 'JFK@example.com',
      phone: '+421903111111'
    },
    paymentOption: {
      ...paymentOptionsMock[0].paymentOptions[0]
    },
    note: null,
    migrationPromotion: {
      applicable: false,
      needAssistance: null,
      uploadedFiles: [],
    },
    items: [
      // DOMAIN
      domainItemsMock[0],
      // BUSINESS MAIL connected to SK domain domainItems[0]
      {
        id: 4574862,
        code: 'business-mail',
        period: 12,
        prolongPeriod: 12,
        sellType: 'direct',
        properties: {
          packageId: '3b086020-ed05-469c-aed4-a142063e88b9',
          addons: {
            'advanced_licences_limit': 1
          },
          packageDetail: {
            id: '3b086020-ed05-469c-aed4-a142063e88b9',
            marketingName: {
              sk: 'Biznis Mail'
            },
            prices: [
              {
                period: 12,
                prolongPrice: 0,
                newPrice: 0
              },
              {
                period: 6,
                prolongPrice: 0,
                newPrice: 0
              },
              {
                period: 3,
                prolongPrice: 0,
                newPrice: 0
              }
            ],
            addons: [
              {
                type: 'numeric',
                step: 1,
                max: null,
                monthlyPrice: 1.99,
                name: 'basic_licences_limit'
              },
              {
                type: 'numeric',
                step: 1,
                max: null,
                monthlyPrice: 3.99,
                name: 'advanced_licences_limit'
              },
              {
                type: 'numeric',
                step: 1,
                max: null,
                monthlyPrice: 6.99,
                name: 'premium_licences_limit'
              }
            ],
            parameters: []
          },
          domain: 'frfrfrfrfrfr.sk',
          freeTrial: true
        },
        options: {
          period: [
            {
              period: 3,
              price: 11.97,
              onlyCardPayment: false
            },
            {
              period: 6,
              price: 23.94,
              onlyCardPayment: false
            },
            {
              period: 12,
              price: 47.88,
              onlyCardPayment: false
            }
          ]
        },
        price: {
          vatExcluded: 47.88,
          discountReason: 'free_trial',
          originalPrice: null
        },
        coupon: null,
        mandatoryEditableProperties: [
          'domain'
        ],
        optionalEditableProperties: [
          'addons'
        ],
        mossFlow: [
          'domain-checker'
        ],
        settings: {
          addons: [
            {
              type: 'numeric',
              step: 1,
              monthlyPrice: 1.99,
              name: 'basic_licences_limit',
              base: 0,
              value: 0,
              filters: {
                min: 0,
                max: null
              }
            },
            {
              type: 'numeric',
              step: 1,
              monthlyPrice: 3.99,
              name: 'advanced_licences_limit',
              base: 0,
              value: 1,
              filters: {
                min: 1,
                max: null
              }
            },
            {
              type: 'numeric',
              step: 1,
              monthlyPrice: 6.99,
              name: 'premium_licences_limit',
              base: 0,
              value: 0,
              filters: {
                min: 0,
                max: null
              }
            }
          ]
        },
        removable: true,
        prolongPrice: {
          vatExcluded: 47.88,
          discountReason: 'free_trial',
          originalPrice: 47.88
        },
        gaee: {
          id: 'business-email',
          name: 'Business Email',
          categories: [
            'Email'
          ],
          brand: 'Websupport',
          price: 47.88,
          quantity: 1
        }
      },
      {
        id: 4575873,
        code: 'vdc',
        period: 12,
        prolongPeriod: 12,
        sellType: 'direct',
        properties: {
          cpu: 16,
          ram: 43008,
          capacity: 327680,
          ip: 4,
          monitoring: true,
          management: true,
          backup: false,
          name: 'HelpMeSecretMessage'
        },
        options: {
          period: [
            {
              period: 1,
              price: 528.6,
              onlyCardPayment: true
            },
            {
              period: 6,
              price: 3013.02,
              onlyCardPayment: false
            },
            {
              period: 12,
              price: 5708.88,
              onlyCardPayment: false
            }
          ]
        },
        price: {
          vatExcluded: 5708.88,
          discountReason: 'user',
          originalPrice: 6343.2
        },
        coupon: null,
        mandatoryEditableProperties: [
          'name'
        ],
        optionalEditableProperties: [
          'monitoring',
          'management',
          'backup'
        ],
        mossFlow: [],
        settings: [],
        removable: true,
        prolongPrice: {
          vatExcluded: 5708.88,
          discountReason: 'user',
          originalPrice: 5708.88
        },
        gaee: {
          id: 'vdc-3',
          name: 'VDC 3',
          categories: [
            'Server',
            'Virtual Data Center'
          ],
          brand: 'Websupport',
          price: 5708.88,
          quantity: 1
        }
      },
      {
        id: 4575996,
        code: 'website-builder',
        period: 12,
        prolongPeriod: 12,
        sellType: 'direct',
        properties: {
          packageId: '40828104-6aeb-4b55-9723-b66a5ed81d53',
          addons: {
            addon_email_storage: 30
          },
          packageDetail: {
            id: '40828104-6aeb-4b55-9723-b66a5ed81d53',
            marketingName: {
              en: 'Large'
            },
            prices: [
              {
                period: 12,
                prolongPrice: 14.99,
                newPrice: 14.99
              },
              {
                period: 1,
                prolongPrice: 19.99,
                newPrice: 19.99
              }
            ],
            addons: [
              {
                type: 'numeric',
                step: 10240,
                max: 102400,
                monthlyPrice: 1,
                name: 'addon_email_storage'
              }
            ],
            parameters: [
              {
                type: 'text',
                value: 'webnode',
                name: 'vendor'
              },
              {
                type: 'text',
                value: 'business',
                name: 'subscription'
              },
              {
                type: 'text',
                value: 'odin',
                name: 'email_platform'
              },
              {
                type: 'numeric',
                value: 3072,
                name: 'email_storage_size'
              },
              {
                type: 'numeric',
                value: 15360,
                name: 'web_disk_size'
              },
              {
                type: 'boolean',
                value: true,
                name: 'eshop'
              },
              {
                type: 'unlimited',
                name: 'number_of_pages'
              }
            ]
          },
          emailStorageWithAddon: 33792
        },
        options: {
          period: [
            {
              period: 12,
              price: 215.88,
              onlyCardPayment: false
            },
            {
              period: 1,
              price: 22.99,
              onlyCardPayment: true
            }
          ]
        },
        price: {
          vatExcluded: 215.88,
          discountReason: null,
          originalPrice: null
        },
        coupon: null,
        mandatoryEditableProperties: [],
        optionalEditableProperties: [
          'addons',
          'domain'
        ],
        mossFlow: [],
        settings: {
          addons: [
            {
              type: 'numeric',
              step: 10,
              monthlyPrice: 1,
              name: 'addon_email_storage',
              base: 3,
              value: 33,
              filters: {
                min: 3,
                max: 103
              }
            }
          ]
        },
        removable: true,
        prolongPrice: {
          vatExcluded: 215.88,
          discountReason: null,
          originalPrice: 215.88
        },
        gaee: {
          id: 'sitebuilder-large',
          name: 'SiteBuilder Large',
          categories: [
            'Web Hosting'
          ],
          brand: 'Websupport',
          price: 215.88,
          quantity: 1
        }
      },
      {
        id: 4576029,
        code: 'vps',
        period: 12,
        prolongPeriod: 12,
        sellType: 'direct',
        properties: {
          osName: 'Ubuntu 24.04',
          osTemplate: 'minimal',
          cpu: 4,
          ram: 4096,
          capacity: 81920,
          snapshotSlot: 3,
          name: null
        },
        options: {
          period: [
            {
              period: 1,
              price: 56.2,
              onlyCardPayment: true
            },
            {
              period: 3,
              price: 168.6,
              onlyCardPayment: false
            },
            {
              period: 6,
              price: 320.34,
              onlyCardPayment: false
            },
            {
              period: 12,
              price: 606.96,
              onlyCardPayment: false
            }
          ]
        },
        price: {
          vatExcluded: 606.96,
          discountReason: 'user',
          originalPrice: 674.4
        },
        coupon: null,
        mandatoryEditableProperties: [
          'name',
          'snapshotSlot'
        ],
        optionalEditableProperties: [
          'monitoring',
          'management',
          'backup'
        ],
        mossFlow: [],
        settings: [],
        removable: true,
        prolongPrice: {
          vatExcluded: 606.96,
          discountReason: 'user',
          originalPrice: 606.96
        },
        gaee: {
          id: 'linux-vps-standard',
          name: 'Linux VPS Standard',
          categories: [
            'Server',
            'Virtual Private Server'
          ],
          brand: 'Websupport',
          price: 606.96,
          quantity: 1
        }
      },
      {
        id: 4576053,
        code: 'hosting',
        period: 12,
        prolongPeriod: 12,
        sellType: 'direct',
        properties: {
          packageId: '99e1ced4-61bb-41fa-9a3f-ec4f6e7e1041',
          addons: {
            storage: 5,
            assignments: 1
          },
          packageDetail: {
            id: '99e1ced4-61bb-41fa-9a3f-ec4f6e7e1041',
            marketingName: {
              en: 'Smart'
            },
            prices: [
              {
                period: 12,
                prolongPrice: 4.99,
                newPrice: 3.99
              },
              {
                period: 6,
                prolongPrice: 5.99,
                newPrice: 5.99
              },
              {
                period: 3,
                prolongPrice: 5.99,
                newPrice: 5.99
              },
              {
                period: 1,
                prolongPrice: 5.99,
                newPrice: 5.99
              }
            ],
            addons: [
              {
                type: 'numeric',
                step: 5120,
                max: 30720,
                monthlyPrice: 1,
                name: 'storage'
              },
              {
                type: 'numeric',
                step: 1,
                max: 2,
                monthlyPrice: 1,
                name: 'assignments'
              },
              {
                type: 'boolean',
                monthlyPrice: 3,
                name: 'extended_php_support'
              }
            ],
            parameters: [
              {
                type: 'numeric',
                value: 20480,
                name: 'storage_capacity'
              },
              {
                type: 'numeric',
                value: 3,
                name: 'total_assignments_limit'
              },
              {
                type: 'unlimited',
                name: 'website_limit'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'windows_web_limit'
              },
              {
                type: 'unlimited',
                name: 'linux_web_limit'
              },
              {
                type: 'unlimited',
                name: 'linux_wordpress_limit'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'linux_managed_wordpress_limit'
              },
              {
                type: 'unlimited',
                name: 'linux_redirect_limit'
              },
              {
                type: 'numeric',
                value: 1000,
                name: 'database_total_limit'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'database_mssql_limit'
              },
              {
                type: 'unlimited',
                name: 'email_accounts'
              },
              {
                type: 'unlimited',
                name: 'email_aliases'
              },
              {
                type: 'unlimited',
                name: 'email_mailbox_quota'
              },
              {
                type: 'text',
                value: 'normal',
                name: 'email_rate'
              },
              {
                type: 'text',
                value: 'hour',
                name: 'shell_console'
              },
              {
                type: 'numeric',
                value: 512,
                name: 'php_memory_limit'
              },
              {
                type: 'boolean',
                value: false,
                name: 'higher_hosting_performance'
              },
              {
                type: 'boolean',
                value: false,
                name: 'premium_performance'
              },
              {
                type: 'boolean',
                value: false,
                name: 'key_value_store'
              },
              {
                type: 'text',
                value: 'odin',
                name: 'default_linux_hosting_platform'
              },
              {
                type: 'text',
                value: 'whp',
                name: 'default_windows_hosting_platform'
              },
              {
                type: 'text',
                value: 'odin',
                name: 'default_email_platform'
              },
              {
                type: 'numeric',
                value: 100,
                name: 'cpu_cores_percentage_limit'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'ram'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'kv_store_cache_size'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'opcache'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'varnish_cache'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'ftp_account_limit'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'database_size'
              },
              {
                type: 'boolean',
                value: false,
                name: 'backup_scheduling'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'cron_jobs'
              },
              {
                type: 'boolean',
                value: false,
                name: 'version_control'
              },
              {
                type: 'numeric',
                value: 0,
                name: 'php_workers'
              },
              {
                type: 'boolean',
                value: false,
                name: 'shared_hosting_storage'
              }
            ]
          },
          assignmentsWithAddon: 4,
          storageWithAddon: 25600
        },
        options: {
          period: [
            {
              period: 12,
              price: 71.88,
              onlyCardPayment: false
            },
            {
              period: 6,
              price: 47.94,
              onlyCardPayment: false
            },
            {
              period: 3,
              price: 23.97,
              onlyCardPayment: false
            },
            {
              period: 1,
              price: 7.99,
              onlyCardPayment: true
            }
          ]
        },
        price: {
          vatExcluded: 71.88,
          discountReason: null,
          originalPrice: null
        },
        coupon: null,
        mandatoryEditableProperties: [],
        optionalEditableProperties: [
          'addons'
        ],
        mossFlow: [
          'domain-checker'
        ],
        settings: {
          addons: [
            {
              type: 'numeric',
              step: 5,
              monthlyPrice: 1,
              name: 'storage',
              base: 20,
              value: 25,
              filters: {
                min: 20,
                max: 50
              }
            },
            {
              type: 'numeric',
              step: 1,
              monthlyPrice: 1,
              name: 'assignments',
              base: 3,
              value: 4,
              filters: {
                min: 3,
                max: 5
              }
            },
            {
              type: 'boolean',
              monthlyPrice: 3,
              name: 'extended_php_support',
              value: false,
              filters: {
                'disabled': false
              }
            }
          ]
        },
        removable: true,
        prolongPrice: {
          vatExcluded: 83.88,
          discountReason: null,
          originalPrice: 83.88
        },
        gaee: {
          id: 'hosting-smart',
          name: 'Hosting Smart',
          categories: [
            'Web Hosting'
          ],
          brand: 'Websupport',
          price: 71.88,
          quantity: 1
        }
      }
    ],
    donation: {
      current: {
        roundUpVersion: null,
        customDonation: 0,
        donationVatExcluded: 0,
      },
      options: [
        {
          roundUpVersion: 'v1',
          donation: 0.32,
          totalPriceVatIncluded: 11,
        },
        {
          roundUpVersion: 'v2',
          donation: 0.82,
          totalPriceVatIncluded: 11.5,
        },
        {
          roundUpVersion: 'v3',
          donation: 1.82,
          totalPriceVatIncluded: 12.5,
        },
      ],
    },
    summary: {
      count: 4,
      price: {
        vatExcluded: 1471.48,
        vatIncluded: 1765.776,
        vatOnly: 294.296,
        vatPercentage: 20,
      },
      currency: {
        name: 'EUR',
        symbol: '\u20ac',
      },
      coupons: [
        {
          code: 'ABXJ3L2QTL',
          bonuses: [
            {
              property: 'bonus.property.capacity',
              value: '100.00',
              percentage: false,
            },
          ],
        },
      ],
    },
    user: {
      id: 185005,
      login: 'kokosvelky',
      customerType: 'new',
      emails: ['example@example.com'],
    },
    uuid: 2707,
  };
}

export const storageItem: CartItem = {
  id: 326395,
  code: 'storage',
  period: 12,
  prolongPeriod: 12,
  sellType: 'direct',
  removable: true,
  properties: {
    capacity: 884736,
  },
  options: {
    period: [
      {
        period: 1,
        price: 126.56,
        onlyCardPayment: true,
      },
      {
        period: 6,
        price: 721.39,
        onlyCardPayment: false,
      },
      {
        period: 12,
        price: 1366.85,
        onlyCardPayment: false,
      },
    ],
  },
  price: {
    vatExcluded: 1366.85,
    discountReason: 'user',
    originalPrice: 1518.72,
  },
  coupon: null,
  mandatoryEditableProperties: ['name'],
  optionalEditableProperties: [],
  mossFlow: [],
  gaee: {
    id: 'storage',
    name: 'Storage',
    categories: ['Server'],
    brand: 'Websupport',
    price: '1366.85',
    quantity: 1,
  },
  prolongPrice: {
    vatExcluded: 1366.85,
    discountReason: 'user',
    originalPrice: 1366.85,
  },
};
export const winLicenceItem: CartItem = {
  id: 326362,
  code: 'windows-licence',
  period: 12,
  prolongPeriod: 12,
  sellType: 'direct',
  removable: true,
  properties: {},
  options: {
    period: [
      {
        period: 12,
        price: 280.8,
        onlyCardPayment: false,
      },
    ],
  },
  price: {
    vatExcluded: 280.8,
    discountReason: null,
    originalPrice: null,
  },
  coupon: null,
  mandatoryEditableProperties: [],
  optionalEditableProperties: [],
  mossFlow: [],
  gaee: {
    id: 'windows-licence',
    name: 'Windows Licence',
    categories: ['Server'],
    brand: 'Websupport',
    price: '280.80',
    quantity: 1,
  },
  prolongPrice: {
    vatExcluded: 280.8,
    discountReason: null,
    originalPrice: 280.8,
  },
};

export const itemsProperties: Record<string, any> = {
  management: {
    name: 'management',
    options: [
      {
        type: 'empty',
        value: 'false',
        prices: [],
      },
      {
        type: 'advanced',
        value: 'true',
        prices: [
          {
            period: 12,
            actualPrice: 1440,
            marketingPrice: 1440,
          },
        ],
      },
    ],
  },
  snapshotSlot: {
    name: 'snapshotSlot',
    options: [
      {
        type: 'slot_1',
        value: '1',
        prices: [
          {
            period: 1,
            actualPrice: 0,
            marketingPrice: null,
          },
          {
            period: 3,
            actualPrice: 0,
            marketingPrice: null,
          },
          {
            period: 6,
            actualPrice: 0,
            marketingPrice: null,
          },
          {
            period: 12,
            actualPrice: 0,
            marketingPrice: null,
          },
        ],
      },
      {
        type: 'slot_2',
        value: '2',
        prices: [
          {
            period: 1,
            actualPrice: 4.9,
            marketingPrice: null,
          },
          {
            period: 3,
            actualPrice: 14.7,
            marketingPrice: null,
          },
          {
            period: 6,
            actualPrice: 29.4,
            marketingPrice: null,
          },
          {
            period: 12,
            actualPrice: 58.8,
            marketingPrice: null,
          },
        ],
      },
      {
        type: 'slot_3',
        value: '3',
        prices: [
          {
            period: 1,
            actualPrice: 9.8,
            marketingPrice: null,
          },
          {
            period: 3,
            actualPrice: 29.4,
            marketingPrice: null,
          },
          {
            period: 6,
            actualPrice: 58.8,
            marketingPrice: null,
          },
          {
            period: 12,
            actualPrice: 117.6,
            marketingPrice: null,
          },
        ],
      },
      {
        type: 'slot_4',
        value: '4',
        prices: [
          {
            period: 1,
            actualPrice: 14.7,
            marketingPrice: null,
          },
          {
            period: 3,
            actualPrice: 44.1,
            marketingPrice: null,
          },
          {
            period: 6,
            actualPrice: 88.2,
            marketingPrice: null,
          },
          {
            period: 12,
            actualPrice: 176.4,
            marketingPrice: null,
          },
        ],
      },
      {
        type: 'slot_5',
        value: '5',
        prices: [
          {
            period: 1,
            actualPrice: 19.6,
            marketingPrice: null,
          },
          {
            period: 3,
            actualPrice: 58.8,
            marketingPrice: null,
          },
          {
            period: 6,
            actualPrice: 117.6,
            marketingPrice: null,
          },
          {
            period: 12,
            actualPrice: 235.2,
            marketingPrice: null,
          },
        ],
      },
    ],
  },
  monitoring: {
    name: 'monitoring',
    options: [
      {
        type: 'empty',
        value: 'false',
        prices: [],
      },
      {
        type: 'advanced',
        value: 'true',
        prices: [
          {
            period: 12,
            actualPrice: 228,
            marketingPrice: 228,
          },
        ],
      },
    ],
  },
  backup: {
    name: 'backup',
    options: [
      {
        type: 'empty',
        value: 'false',
        prices: [],
      },
      {
        type: 'backup',
        value: 'true',
        prices: [
          {
            period: 12,
            actualPrice: 4.8,
            marketingPrice: 4.8,
          },
        ],
        min: 2,
        max: 500,
      },
    ],
  },
};

export const mockBusinessMailItem = {
  id: 2190278,
  code: 'business-mail',
  period: 12,
  prolongPeriod: 12,
  sellType: 'direct',
  removable: true,
  properties: {
    packageId: '3b086020-ed05-469c-aed4-a142063e88b9',
    addons: {
      advanced_licences_limit: 1,
      basic_licences_limit: 1,
      premium_licences_limit: 1
    },
    packageDetail: {
      id: '3b086020-ed05-469c-aed4-a142063e88b9',
      marketingName: {
        sk: 'Biznis Mail'
      },
      prices: [
        {
          period: 12,
          prolongPrice: 0,
          newPrice: 0
        },
        {
          period: 6,
          prolongPrice: 0,
          newPrice: 0
        },
        {
          period: 3,
          prolongPrice: 0,
          newPrice: 0
        }
      ],
      addons: [
        {
          type: 'numeric',
          step: 1,
          max: null,
          monthlyPrice: 1.99,
          name: 'basic_licences_limit'
        },
        {
          type: 'numeric',
          step: 1,
          max: null,
          monthlyPrice: 3.99,
          name: 'advanced_licences_limit'
        },
        {
          type: 'numeric',
          step: 1,
          max: null,
          monthlyPrice: 6.99,
          name: 'premium_licences_limit'
        }
      ],
      parameters: []
    },
    domain: 'mocking-cart.com',
    freeTrial: true
  },
  options: {
    period: [
      {
        period: 3,
        price: 0,
        onlyCardPayment: false
      },
      {
        period: 6,
        price: 0,
        onlyCardPayment: false
      },
      {
        period: 12,
        price: 0,
        onlyCardPayment: false
      }
    ]
  },
  price: {
    vatExcluded: 0,
    discountReason: 'free_trial',
    originalPrice: 47.88
  },
  coupon: null,
  mandatoryEditableProperties: [
    'domain'
  ],
  optionalEditableProperties: [
    'addons'
  ],
  mossFlow: [],
  settings: {
    addons: [
      {
        type: 'numeric',
        step: 1,
        monthlyPrice: 1.99,
        name: 'basic_licences_limit',
        base: 0,
        value: 1,
        filters: {
          min: 0,
          max: null
        }
      },
      {
        type: 'numeric',
        step: 1,
        monthlyPrice: 3.99,
        name: 'advanced_licences_limit',
        base: 0,
        value: 1,
        filters: {
          min: 0,
          max: null
        }
      },
      {
        type: 'numeric',
        step: 1,
        monthlyPrice: 6.99,
        name: 'premium_licences_limit',
        base: 0,
        value: 1,
        filters: {
          min: 0,
          max: null
        }
      }
    ]
  },
  prolongPrice: {
    vatExcluded: 0,
    discountReason: 'free_trial',
    originalPrice: 0
  },
  gaee: {
    id: 'business-email',
    name: 'Business Email',
    categories: [
      'Email'
    ],
    brand: 'Websupport',
    price: 0,
    quantity: 1
  }
};

export const validationError = {
  type: '/errors/validation',
  status: 422,
  title: 'The given data was invalid.',
  violations: [
    {
      propertyPath: 'vatId',
      errors: [
        {
          translationKey: 'validation.required',
        },
      ],
    },
  ],
};

export const errorFromCartValidationAPI = {
  type: '/errors/httpException',
  status: 400,
  title: 'Cart items validation failed.',
  key: 'exception.cart_items.validation.failed',
  context: {
    errors: [
      {
        type: '/errors/exception',
        status: 500,
        title: 'Domain not available.',
        key: 'exception.integrity.domain_not_available',
        context: {
          cartItemId: 3883, // update to one in your cart if needed
          field: 'configuration.domain',
          errors: ['validation.domain_name.not_available'],
          step: 'cart',
        },
      },
    ],
  },
};

export function registerCartMocks(mock: MockAdapter) {
  // Write a message to console as developer notice
  console.info('Registering cart API mocks');

  mock.onGet(/\/cart$/).reply(200, cartMockData);
  mock.onPost(/\/cart\/items/).reply(200, cartMockData);
  mock.onGet(/\/cart\/items\/validate$/).reply(200);
  // mock.onGet(/\/cart\/items\/validate$/).reply(400, errorFromCartValidationAPI);
  mock.onPut(/\/cart/).reply(200, cartMockData);
  // mock.onPut(/\/cart/).reply(422, validationError);
  const props = ['monitoring', 'backup', 'management', 'snapshotSlot'];
  props.forEach(prop => {
    mock
      .onGet(/\/cart\/items\/properties/, {
        params: { property: prop },
      })
      .reply(200, itemsProperties[prop]);
  });
}
